import Button from "@pathwright/ui/src/components/button/Button"
import withTranslate from "@pathwright/ui/src/components/lng/withTranslate"
import Pathicon from "@pathwright/ui/src/components/pathicon/Pathicon"
import classnames from "classnames"
import { LEARN } from "path/constants"
import pluralize from "pluralize"
import "./PathGroupCompletion.css"

const PathGroupCompletion = function (props) {
  const {
    mode,
    stats,
    group,
    isNext,
    analytics,
    nextStepURL,
    expanded,
    isInactive,
    startsDate,
    dueDate,
    onToggleExpand,
    t
  } = props

  const isLocked = startsDate != null
  const toggleIcon = expanded ? "chevron-up" : "chevron-down"

  const className = classnames("PathGroupCompletion", {
    "PathGroupCompletion--inactive": isInactive
  })

  return (
    <div className={className}>
      {mode === LEARN && !expanded && (
        <div className="PathGroupCompletion__action">
          {(isNext || stats.progress === 1) && !isLocked && (
            <Button
              styleType={isInactive ? "secondary" : "primary"}
              size={"large"}
              inverted={isInactive}
              to={nextStepURL}
              brand
            >
              {stats.progress === 0
                ? t("path.group.start")
                : stats.progress < 1
                ? t("path.group.resume")
                : t("path.group.review")}
            </Button>
          )}
        </div>
      )}
      {stats.step_count > 0 && (
        <Button
          onClick={onToggleExpand}
          className="PathGroupCompletion__toggle"
          styleType="blank"
          inverted={isInactive}
          // color={isInactive ? "rgba(255,255,255,0.6)" : "#888"}
        >
          <Pathicon icon={toggleIcon} />
          <span> </span>
          {expanded
            ? `${t("path.group.hide")} `
            : `${t("path.group.show")} `}{" "}
          {stats.step_count}{" "}
          {t(`path.group.${pluralize("step", stats.step_count)}`)}
        </Button>
      )}
    </div>
  )
}

PathGroupCompletion.displayName = "PathGroupCompletion"

export default withTranslate(PathGroupCompletion)
